import {DetailsList, FontSizes, FontWeights, IconButton, SelectionMode, Stack} from "@fluentui/react";
import AuthContext from "../Services/AuthContext";
import * as React from "react";
import {useContext} from "react";

function ProjectCheckList(props) {
    const [user] = useContext(AuthContext);

    const columns = [
        {
            key: 'item',
            name: 'Nazwa',
            ariaLabel: 'Nazwa punktu kontrolnego',
            fieldName: 'item',
            minWidth: 160,
            isRowHeader: true,
            isResizable: true
        },
        {
            key: 'delete',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'delete',
            minWidth: 80,
            isRowHeader: true,
            isResizable: true,
            onRender: (item) => (<span>
                <IconButton iconProps={{iconName: 'trash'}} title='Usuń' onClick={() => _delete(item)}/>
            </span>)
        }
    ];

    const _delete = (check) => {
        fetch(`/api/project/checklist/${check.id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => {
                props.update(props.data.filter((item) => item.id !== check.id))
            })
            .catch(err => {
                console.log(err)
            })
    }
    if (props.data.length) {
        return (<Stack.Item>
            <h2 style={{fontSize: FontSizes.size24, fontWeight: FontWeights.light}}>{props.title}</h2>
            <DetailsList items={props.data} columns={columns} selectionMode={SelectionMode.none}/>
        </Stack.Item>);
    }
    return null;
}

ProjectCheckList.defaultProps = {
    title: 'Lista Kontrolna'
}

export default ProjectCheckList;